import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { replace } from 'connected-react-router';
import { LocationState, Path } from 'history';

import { Params } from './types';

export type Replace = (to: Path, state?: Record<string, unknown>, params?: Params) => void;

export default (): Replace => {
    const dispatch = useDispatch();

    return useCallback(
        <S = LocationState>(to: Path, state?: S, params?: { cancelFetchingData?: boolean }) => {
            dispatch(replace(to, state, params));
        },
        [dispatch]
    );
};
